import { View, VStack } from "@gluestack-ui/themed";
import { NewTransactionValueController } from "./controller";
import { Text } from "@repo/core/components/core/Text";
import { Button } from "@repo/core/components/core/Button";
import Scaffolds from "@repo/core/components/layout/Scaffolds";
import { StatusBarVariantEnum } from "@repo/core/components/layout/StatusBar/types";
import { InputControlled } from "@repo/core/components/forms/InputControlled";
import { ProductItem } from "@repo/core/components/core/ProductItem";

const NewTransactionValue = () => {
  const {
    isMobile,
    control,
    handleOnSubmitForm,
    selectedProduct,
    handleBack,
    title,
    handleOnCancel
  } = NewTransactionValueController();
  return (
    <Scaffolds.Root
      showHeader={false}
      statusBarVariant={StatusBarVariantEnum.STORE_SELECT}
    >
      <Scaffolds.StoreSelect title={title} onBackPress={handleBack}>
        <Scaffolds.Form
          showHeader={false}
          footerContent={
            <View
              w="$full"
              gap="$4"
              flexDirection={!isMobile ? "row-reverse" : "column"}
              pt={isMobile ? "$0" : "$12"}
              px="$4"
              pb="$4"
              justifyContent="flex-end"
            >
              <Button
                flex={isMobile ? undefined : 1}
                size="xl"
                text="Continuar"
                action="secondary"
                onPress={handleOnSubmitForm}
              />
              <Button
                flex={isMobile ? undefined : 1}
                variant="outline"
                action="negative"
                size="xl"
                text="Cancelar"
                onPress={handleOnCancel}
              />
            </View>
          }
        >
          <VStack flex={1} gap={24} px="$4">
            <Text>Insira o valor da compra:</Text>
            <ProductItem
              id="purchaseValue"
              strImagemProduto={selectedProduct?.strBase64LogoProduto}
              strDescrProduto={selectedProduct?.strProdutoDescricao}
              strPlastico={selectedProduct?.strPlasticoTitularNumero}
            />
            <InputControlled
              control={control}
              name="purchaseValue"
              size="md"
              returnKeyType="next"
              label="Valor da compra"
              isRequired
              isCurrency
              isBigInput
              keyboardType="numeric"
            />
          </VStack>
        </Scaffolds.Form>
      </Scaffolds.StoreSelect>
    </Scaffolds.Root>
  );
};

export default NewTransactionValue;
